// JuzList.js
import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// List of all 30 Juz with their starting chapter and verse
export const juzList = [
  { number: 1, chapter: 1, verse: 1 },
  { number: 2, chapter: 2, verse: 142 },
  { number: 3, chapter: 2, verse: 253 },
  { number: 4, chapter: 3, verse: 93 },
  { number: 5, chapter: 4, verse: 24 },
  { number: 6, chapter: 4, verse: 148 },
  { number: 7, chapter: 5, verse: 82 },
  { number: 8, chapter: 6, verse: 111 },
  { number: 9, chapter: 7, verse: 88 },
  { number: 10, chapter: 8, verse: 41 },
  { number: 11, chapter: 9, verse: 93 },
  { number: 12, chapter: 11, verse: 6 },
  { number: 13, chapter: 12, verse: 53 },
  { number: 14, chapter: 15, verse: 1 },
  { number: 15, chapter: 17, verse: 1 },
  { number: 16, chapter: 18, verse: 75 },
  { number: 17, chapter: 21, verse: 1 },
  { number: 18, chapter: 23, verse: 1 },
  { number: 19, chapter: 25, verse: 21 },
  { number: 20, chapter: 27, verse: 56 },
  { number: 21, chapter: 29, verse: 46 },
  { number: 22, chapter: 33, verse: 31 },
  { number: 23, chapter: 36, verse: 28 },
  { number: 24, chapter: 39, verse: 32 },
  { number: 25, chapter: 41, verse: 47 },
  { number: 26, chapter: 46, verse: 1 },
  { number: 27, chapter: 51, verse: 31 },
  { number: 28, chapter: 58, verse: 1 },
  { number: 29, chapter: 67, verse: 1 },
  { number: 30, chapter: 78, verse: 1 }
];

// Main component for displaying the list of Juz
const JuzList = ({
  chapters,
  setSelectedChapter,
  setSelectedAyatNumber,
  navMenuItemClick,
  setViewType
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const getChapterByNumber = (chapterNumber) =>
    chapters.find((chapter) => chapter.number == chapterNumber);

  const handleJuzClick = (juz) => {
    const chapter = getChapterByNumber(juz.chapter);
    if (!chapter) return;

    setSelectedChapter(chapter);

    setSelectedAyatNumber(juz.verse);
    navMenuItemClick("read");
  };

  return (
    <Box mt={12} sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
          maxWidth: '1000px',
          justifyContent: isMobile ? 'center' : 'flex-start',
        }}
      >
        {juzList.map((juz) => {
          const chapter = getChapterByNumber(juz.chapter);
          return (
            <Box
              key={juz.number}
              onClick={() => handleJuzClick(juz)}
              sx={{
                flex: isMobile ? '1 1 100%' : '1 1 calc(33.33% - 1rem)',
                p: 2,
                borderRadius: '8px',
                border: '1px solid #ddd',
           
                cursor: 'pointer',
              }}
            >
              <Typography variant="default_body">
                <strong>Juz {juz.number}</strong>
                {chapter && ` — ${chapter.title} [${juz.chapter}:${juz.verse}]`}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default JuzList;
